import { Button } from '@components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@components/ui/card'
import { Input } from '@components/ui/input'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet'

const VerifyPasswordView: FC = () => {
  return (
    <>
      <Helmet>
        <title>Verify password | Ancho</title>
      </Helmet>

      <Card className="max-w-sm">
        <CardHeader>
          <CardTitle>Verify password</CardTitle>
          <CardDescription>
            Please enter your password to continue.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form className="w-full flex flex-col items-center [&>button]:mt-2">
            <Input type="password" placeholder="Password" />
            <Button type="submit">Continue</Button>
          </form>
        </CardContent>
      </Card>
    </>
  )
}

export default VerifyPasswordView
